import React from 'react';
import { createPortal } from 'react-dom';

import Show from 'components/Show';
import Button from 'components/Ui/Button';

const Modal = ({ title, visible, onModal, children, footer }) => {
	// Do not append modal to body unless visible
	if (!visible) return null;

	return createPortal(
		<div className="fixed top-0 right-0 bottom-0 left-0 z-10 flex justify-center items-center bg-[rgba(0,0,0,0.15)] dark:bg-[rgba(0,0,0,0.55)] backdrop-blur-sm">
			<div className="w-full h-full md:h-auto flex flex-col md:max-w-lg max-h-full bg-white dark:bg-neutral-900 md:rounded-lg overflow-hidden animate-fade-in">
				<div className="py-4 px-4 pl-6 flex justify-between items-center">
					<div className="text-xl font-semibold text-neutral-700 dark:text-white">
						{title}
					</div>

					<Button icon="close" theme="transparent" square onClick={onModal} />
				</div>

				<div className="px-4 pb-4 h-full max-h-full overflow-y-auto">
					{children}
				</div>

				<Show if={footer}>
					{footer}
				</Show>
			</div>
		</div>
		, document.body);
};

export default Modal;